const baseStyle = {
    // Override to fix braintree-drop-in styling that was getting messed up by the chakra css reset rules
    '.braintree-option': {
        borderColor: '#B5B5B5',
    },

    // Ensure the drop-in container takes full width
    '.braintree-dropin': {
        width: '100%',
    },

    // The sheet should take full width
    '.braintree-sheet': {
        width: '100%',
    },

    // Form content padding
    '.braintree-sheet__content--form': {
        padding: '10px 15px 10px 10px',
    },

    // Flexible fields container - ensure proper flex behavior
    '.braintree-form__flexible-fields': {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '10px',
    },

    // Field groups - give them proper flex basis to allow natural wrapping
    '.braintree-form__field-group': {
        flexBasis: '140px',
        flexGrow: 1,
        minWidth: '120px',
        marginBottom: '10px',
    },

    // Labels should not truncate
    '.braintree-form__label': {
        fontSize: '14px',
        whiteSpace: 'normal',
        overflow: 'visible',
    },

    // Hosted field containers need proper sizing
    '.braintree-form__hosted-field': {
        height: '44px',
        minWidth: '80px',
    },
}

export default {
    baseStyle,
}
